import React from "react";

export const MessageContext = React.createContext();
export const MessageDispatchContext = React.createContext();


function MessageProvider({children}) {
    const [state,setstate] = React.useState(0)
    return(
        <MessageContext.Provider value={state}>
            <MessageDispatchContext.Provider value={setstate} >
                {children}
            </MessageDispatchContext.Provider>
        </MessageContext.Provider>
    )
}

export {MessageProvider};
